export default function Footer() {
  return (
    <footer className="footer-main">
      {new Date().getFullYear()} - RecoveryLink{" "}
    </footer>
  )
}
